module.exports = __webpack_public_path__ + "static/media/Seni Sama Sama.961dd82f.png";